import bookDistribution1 from "../../../assets/images/book-distribution1.jpg";
import bookDistribution2 from "../../../assets/images/book-distribution2.jpg";
import bookDistribution3 from "../../../assets/images/book-distribution3.jpg";
import bookDistribution4 from "../../../assets/images/book-distribution4.jpg";
import bookDistribution5 from "../../../assets/images/book-distribution5.jpg";
import bookDistribution6 from "../../../assets/images/book-distribution6.jpg";
import bookDistribution7 from "../../../assets/images/book-distribution7.jpg";
import bookDistribution8 from "../../../assets/images/book-distribution8.jpg";
import bookDistribution9 from "../../../assets/images/book-distribution9.jpg";

export const bookDistributionImages = [
  {
    id: 1,
    image: bookDistribution1,
  },
  {
    id: 2,
    image: bookDistribution2,
  },
  {
    id: 3,
    image: bookDistribution3,
  },
  {
    id: 4,
    image: bookDistribution4,
  },
  {
    id: 5,
    image: bookDistribution5,
  },
  {
    id: 6,
    image: bookDistribution6,
  },
  {
    id: 7,
    image: bookDistribution7,
  },
  {
    id: 8,
    image: bookDistribution8,
  },
  {
    id: 9,
    image: bookDistribution9,
  },
];

export const bookDistribution = [
  ' "Books are the foundation", as Srila Prabhupad always said. The significance of disseminating Srila Prabhupad’s transcendental literature cannot be overstated. On numerous occasions, it has been observed that Srila Prabhupad prioritised the publication and distribution of books over the construction of temples or any other societal activity. The mission of Sri Chaitanya Mahaprabhu was spread throughout the world thanks to Srila Prabhupad’s transcendental books. This was also the state of mind of his spiritual master, Srila Bhakti Siddhanta Saraswati Thakur Prabhupad, who wrote volumes upon volumes of transcendental literature. As a result, book distribution remains one of the most important services provided by devotees.',

  "Contact Details:",
];

export const contactDetails = [
  {
    id: 1,
    number: "Adi Guru Das: +91 74051 60363",
  },
  {
    id: 2,
    number: "Bhakt Paresh: +91 70161 36585",
  },
];
